// ----------------------------------------------------------------------
// <copyright file="Izenda.WeeklyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var NumericInput = require('share/components/controls/Izenda.NumericInput');
  var ScheduleConstants = require('logic/data/Izenda.ScheduleConstants');
  var localizer = require('share/localization/Izenda.Localizer');
  const { pull, join, split, indexOf } = require('lodash/fp');
  var WeeklyRecurrence = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function() {
      this.recurrence = this.props.data.weeklyRecurrencePatternSetting;
      this.days = [];
    },

    /**
     * Get recur every input
     * @return {number} recurrence week
     */
    getRecurEvery: function() {
      return this.recurrence.recurrenceWeek;
    },

    /**
     * onchange recur every input
     * @param {object} data
     */
    onChangeRecurEvery: function(data) {
      this.recurrence.recurrenceWeek = data;
      this.props.data.markDirty();
    },

    /**
     * onchange day
     * @param {object} data
     */
    onChangeDay: function(input) {
      var d = input.target;
      if (d.checked) {
        this.days.push(d.value);
      } else {
        this.days = pull(d.value, this.days);
      }
      this.recurrence.selectedDayValue = join(',', this.days);
      this.props.data.markDirty();
    },

    /**
     * Get checked
     */
    getChecked: function(dayOfWeek) {
      this.days = this.recurrence.selectedDayValue.length > 0 ? split(',', this.recurrence.selectedDayValue) : [];
      return indexOf(dayOfWeek.toString(), this.days) >= 0;
    },

    /**
     * Render
     * @return {object} component
     */
    render: function() {
      return (
        <div>
          <div className="form-group">
            <div className="col-md-3 control-label">{localizer.getText('SUBSCRIPTION_LABEL_RECUR_EVERY')}</div>
            <div className="col-md-3">
              <NumericInput value={this.getRecurEvery()} onChange={this.onChangeRecurEvery} max={Math.pow(2, 32)} />
            </div>
            <div className="col-md-3 control-label no-padding-left">
              {localizer.getText('SUBSCRIPTION_LABEL_WEEKS')}{' '}
            </div>
          </div>
          <div className="form-group">
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.SUNDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.SUNDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_SUNDAY')}</span>
            </div>
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.MONDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.MONDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_MONDAY')}</span>
            </div>
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.TUESDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.TUESDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_TUESDAY')}</span>
            </div>
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.WEDNESDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.WEDNESDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_WEDNESDAY')}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.THURSDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.THURSDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_THURSDAY')}</span>
            </div>
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.FRIDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.FRIDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_FRIDAY')}</span>
            </div>
            <div className="col-md-3">
              <input
                type="checkbox"
                value={ScheduleConstants.DAYOFWEEK.SATURDAY}
                onChange={this.onChangeDay}
                checked={this.getChecked(ScheduleConstants.DAYOFWEEK.SATURDAY)}
              />
              <span className="radio-label">{localizer.getText('COMMON_LABEL_SATURDAY')}</span>
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = m.observer(WeeklyRecurrence);
})();



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.WeeklyRecurrence.jsx